import axios from 'axios'
import md5 from 'js-md5'
import router from '@/router/index.js'
import {Dialog, Notify} from 'vant';


import customer_act from "./svcodes/customer_actions.json"

import comm_rst from './svcodes/common_results.json'

import customer_rst from "./svcodes/customer_results.json"
import {reactive} from "vue";

export const DOMAIN_DEV = "c.jingcaishengya.com";
export const DOMAIN_PROD = "c.jingcaishengya.com";

export const su =
{
    ...customer_act,
    ...comm_rst,
    ...customer_rst,

    oem : reactive({
        oemValue: 0,
        oemText:'',
    }),

    Domain : ()=> {
        if(process.env.NODE_ENV === "development") {
            return DOMAIN_DEV
        }
        return DOMAIN_PROD
    },

    SiteRoot : ()=>{
        return "http://"+su.Domain();
    },

    WebRoot : ()=> {
        return "http://"+su.Domain()+"/gateway"
    },

    ServiceRoot : ()=> {
        return su.WebRoot()+"/svc-customer"
    },

    GetSessionKey : () => {
        let skey = localStorage.getItem('server-token');
        if(skey) {
            return skey
        }
        return ''
    },

    SendSessionRequest(url, vcode, vdata, vheader, vtimeout, cancelSource)
    {
        var p = new Promise(function(resolve, reject)
        {
            let acfg = {
                timeout: vtimeout,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'skey': su.GetSessionKey(),
                    'code': vcode,
                    ...vheader,
                }}
            if(cancelSource) {
                acfg.cancelToken = cancelSource.token
            }
            axios
                .post(url, vdata, acfg)
                .then(function (rsp) {
                    if(rsp.headers.skey) {
                        localStorage.setItem('server-token', rsp.headers.skey)
                    }
                    if(rsp.headers.dbgval==0) {
                        sessionStorage.setItem("debug-mode", 0)
                    }else if(rsp.headers.dbgval) {
                        sessionStorage.setItem("debug-mode", rsp.headers.dbgval*1)
                    }
                    resolve(rsp);

                    if(process.env.NODE_ENV=='development') {
                        for(let item in su) {
                            if(su[item]==vcode) {
                                console.log("ACTION: "+item)
                            }
                        }
                        console.log(rsp)
                    }
                })
                .catch(function (rsp) {
                    reject(rsp);
                })
        });
        return p;
    },

    async ServerCommunication(vcode, vdata, options)
    {
        var vheader = {}
        var vtimeout = 15000
        var posturl = su.ServiceRoot()+'/customer/api'
        const CancelToken = axios.CancelToken;
        const cancelSource = CancelToken.source();
        if(options)
        {
            if(options.postpath) {
                posturl = su.WebRoot() + options.postpath
            }
            if(options.headers) {
                vheader = options.headers
            }
            if(options.timeout) {
                vtimeout = options.timeout
            }
            if(options.fnAbort)
            {
                options.fnAbort(cancelSource)
            }

            // if(options.nlog) {
            //     posturl = su.ServiceRoot()+'/nlog/api'
            // }

        }else {
            options = {}
        }

        let rsp = {}
        try
        {
            rsp = await su.SendSessionRequest(posturl, vcode, vdata, vheader, vtimeout, cancelSource)
        }catch (err)
        {
            //显示网络错误
            Notify({ type: 'danger', message: '网络通信异常！'});

            throw err
        }

        if(rsp.headers['service-year'])
        {
            localStorage.setItem("service-year", rsp.headers['service-year'])
        }

        if(rsp.data.result == 1) //成功完成通信
        {
            return rsp.data.rspobj
        }else if(rsp.data)
        {
            //警告，这个顺序不要改变，如果有 fnErrorHandler，那fnErrorHandler全权处理所有错误
            //所以要先运行 fnErrorHandler，如果 no_default==false，才继续用默认错误处理流程处理
            let no_default = false
            if(options.fnErrorHandler) {
                no_default = options.fnErrorHandler(rsp.data)
            }
            //这个错误必须抛出，目的是为了调用本函数的地方，去改变正常操作流程
            if(no_default)
                throw rsp.data

            if(rsp.data.result==su.SESSION过期或无效)
            {
                try
                {
                    await Dialog.confirm({
                        title: '温馨提示',
                        message: "您的登录信息已过期！",
                        allowHtml:true,
                        confirmButtonText:"去登录",
                    })
                    router.push({name:'login'})
                }catch {
                    if(options.loginCancelRedirect) {
                        if(options.loginCancelRedirect!=1) {
                            router.push({name:options.loginCancelRedirect})
                        }else {
                            throw rsp.data
                        }
                    }else {
                        router.push({name:'home'})
                    }
                }
            }else if(rsp.data.result==su.没有权限)
            {
                try
                {
                    await Dialog.confirm({
                        title: '温馨提示',
                        message: "您的服务不包含本内容！<br>详情可咨询您的专员",
                        allowHtml:true,
                        confirmButtonText:"回首页",
                    })
                    router.push({name:'home'})
                }catch {
                    router.push({name:'home'})
                }

            }else if(rsp.data.result==su.个人信息未填写)
            {
                try {
                    await Dialog.confirm({
                        title: '温馨提示',
                        message: "您尚未填写个人信息~<br>请先去填写信息后再测评！",
                        confirmButtonText: "现在填写",
                        allowHtml: true,
                    })
                    router.push({name: 'my-info'})
                }catch {
                    console.log("nothing")
                }
            }else if(rsp.data.result==su.无权登录) {
                try {
                    await Dialog.confirm({
                        message: "您的服务已到期！",
                        allowHtml: true,
                    })
                    localStorage.clear()
                    router.push({name: 'login'})
                }catch {
                    localStorage.clear()
                    router.push({name:'login'})
                }
            }else { //通信正常，但是服务器返回其他错误
                if(rsp.data.ui) {
                    su.ProcessUIMsg(rsp.data)
                }
                throw rsp.data
            }
        }

        return {}
    },

    md5pwd(password)
    {
        return md5("_md5mix_"+password);
    },

    DeleteSessionKey(){
        return localStorage.removeItem('server-token');
    },

    async CheckSession(opt)
    {
        let vdatapost = {}
        let postopt = {}
        if(opt)
        {
            if(opt.force) {
                vdatapost.cmd = "recache"
            }
            if(opt.loginCancelRedirect) {
                postopt.loginCancelRedirect=opt.loginCancelRedirect
            }
        }
        try
        {
            //借用 dbgType 表达是否要强制刷新
            let dataret = await su.ServerCommunication(su.客户个人信息获取, vdatapost, postopt)
            su.StoreLoginInfo(dataret)
        }catch
        {
            return false
        }

        return true
    },

    ReadDebugMode()
    {
        let dstr = sessionStorage.getItem("debug-mode")
        if(dstr) {
            return dstr*1
        }
        return 0
    },

    CurrentYear()
    {
        let ystr = localStorage.getItem("service-year")
        if(ystr) {
            return ystr*1
        }
        return 2024
    },

    GetLoginInfoObj()
    {
        var json = localStorage.getItem('login-info');
        if(!json) {
            return {name:'', phone:'', payed:false};
        }
        return JSON.parse(json)
    },

    async CheckLoginInfoObj()
    {
        let skey = su.GetSessionKey()
        let lobj = su.GetLoginInfoObj()
        if(skey && !lobj.hasInfo)
        {
            try {
                await Dialog.confirm({
                    title: '温馨提示',
                    message: "您尚未填写个人信息~<br>请先去填写信息！",
                    confirmButtonText: "现在填写",
                    allowHtml: true,
                })
                router.push({name: 'my-info'})
            }catch {
                router.push({name: 'home'})
            }
            return null
        }
        return lobj
    },

    StoreLoginInfo(login_info)
    {
        localStorage.setItem('login-info', JSON.stringify(login_info))
    },

    GetLoginInfo()
    {
        return JSON.parse(localStorage.getItem('login-info'))
    },

    ClearStorage()
    {
        localStorage.removeItem('server-token');
        localStorage.removeItem('login-info');
    },

    sleep : (time) =>{
        return new Promise((resolve) => setTimeout(resolve, time));
    },

    ProcessUIMsg(apirsp)
    {

        if(!apirsp.ui || !apirsp.ui.msg)
            return;

        Notify({ type: 'danger', message: apirsp.ui.msg});
    },

    RawPost(url, vdata) {
        var p = new Promise(function(resolve, reject)
        {
            axios
                .post(url, vdata,
                    {
                        timeout: 30000,
                    }
                )
                .then(function (rsp) {
                    resolve(rsp.data);
                })
                .catch(function (rsp) {
                    reject(rsp);
                })
        });
        return p;
    },


}
export default
{
    install: (app) => {
        app.config.globalProperties['$su'] = su
    }
}